module.exports = __webpack_public_path__ + "media/images/icons/SVG/060-9a5e2fa96c6685dfd718f8aa89e1f6eb.svg";